import { render } from "./ValidationRow.vue?vue&type=template&id=226b77a3"
import script from "./ValidationRow.vue?vue&type=script&lang=js"
export * from "./ValidationRow.vue?vue&type=script&lang=js"

import "./ValidationRow.vue?vue&type=style&index=0&id=226b77a3&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__